import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import Menu from '@mui/material/Menu';

import COLORS from '@styles/theme/colors';

export const User = styled('div')({
  display: 'flex',
  position: 'relative'
});

export const UserPhoto = styled('div')({
  width: 45,
  flex: '0 0 auto',
  height: 45,
  borderRadius: '50%',
  overflow: 'hidden',
  display: 'flex',
  backgroundColor: COLORS.gray,
  cursor: 'pointer',

  '& > img': {
    margin: 'auto',
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },

  '& > svg': {
    margin: 'auto',
    color: COLORS.textColor
  }
});

export const DropDownMenu = styled(Menu)({
  borderRadius: 4,
  boxShadow: '0px 0px 22px rgba(28, 37, 44, 0.1)',
  marginTop: 12
});

export const UserInfo = styled('div')(({ theme }) => ({
  padding: '13px 20px',

  '& .name': {
    color: theme.palette.text.secondary,
    fontWeight: 600,
    fontSize: 14,
    lineHeight: 1
  }
}));

export const SignOut = styled('a')(({ theme }) => ({
  textDecoration: 'none',
  padding: '0 20px 0px 20px',
  display: 'block',
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.primary.main,
  cursor: 'pointer'
}));

export const DdLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  padding: '0 20px 0px 20px',
  display: 'block',
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.primary.main,
  cursor: 'pointer',
  margin: '0 0 10px'
}));
